import React from "react";
import "./Logo.css";

const Logo = ({ url, style }) => (
  <img style={style} className="logo__img" src={url} alt="" />
);

export default Logo;
